import React from 'react';
import { Text } from 'react-native';
import styles from './styles';

function Paragraph({
	children, content, center, urgent, color,
}) {
	return (
		<Text
			style={[
				styles.paragraph,
				center && styles.paragraphCenter,
				urgent && styles.paragraphUrgent,
				color && { color: color},
			]}
		>
			{children || content}
		</Text>
	);
}

export default Paragraph;
